var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTienda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-tote-24-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9106 21.25C25.9518 13.5121 33.6846 7.08333 42.4999 7.08333C51.3153 7.08333 59.0481 13.5121 60.0893 21.25H70.2913C74.2034 21.25 77.3747 24.4213 77.3747 28.3333C77.3747 28.6685 77.3509 29.0033 77.3035 29.3351L71.2321 71.8351C70.7335 75.3247 67.7449 77.9167 64.2199 77.9167H20.7799C17.2549 77.9167 14.2663 75.3247 13.7678 71.8351L7.69636 29.3351C7.14312 25.4624 9.83407 21.8744 13.7068 21.3212C14.0386 21.2738 14.3733 21.25 14.7085 21.25H24.9106ZM52.8695 21.25C51.7929 17.489 47.4513 14.1667 42.4999 14.1667C37.5486 14.1667 33.207 17.489 32.1304 21.25H52.8695ZM14.7085 28.3333H24.7916V35.4167H31.8749V28.3333H53.1249V35.4167H60.2083V28.3333H70.2913L64.2199 70.8333H20.7799L14.7085 28.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTienda);
export default __webpack_public_path__ + "static/media/tienda.29861d7f1964426ce1fc218ef2b16466.svg";
export { ForwardRef as ReactComponent };